import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import EfButton from '@elem/ui/ef-button';
import EcoEmail from 'eco-design/elements/eco-email';
import { useLang } from '@/i18n';
import { lang } from './lang';
import { IPageStatus } from '@elem/compPage/delta-3-max-series/config/IPageStatus';
import { useProductStore } from '../../../ProductProvider';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/getLocal';

const ProductRecommend: React.FC = () => {
    const { t } = useLang('Delta3MaxSeriesPreheat.product_recommend');
    const { pageStatus } = useProductStore();
    const { locale } = getLocal();
    const langText = lang[locale];
    const recommendData = [
        {
            title: t('item1_title'),
            subtitle: t('item1_subtitle'),
            mainImg: 'https://websiteoss.ecoflow.com/upload/image/1756209646018/recommend-img-pc-1-1.jpg',
            mainImgH5: '',
            subImgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756296875482/KSP1%20(2).jpg',
                    h5: '',
                    text: t.rich('item1_sub_desc_1', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756259474472/recommend-img-pc-1-3.jpg',
                    h5: '',
                    text: t.rich('item1_sub_desc_2', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756296985065/recommend-img-pc-1-4.jpg',
                    h5: '',
                    text: t.rich('item1_sub_desc_3', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756259381987/recommend-img-pc-1-5.jpg',
                    h5: '',
                    text: t.rich('item1_sub_desc_4', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
            ],
            label: t('item1_sub_label'),
            introduceTitle: t('item1_sub_introduceTitle'),
            introduceDescArr: [
                t('item1_sub_introduceDescArr_1'),
                t('item1_sub_introduceDescArr_2'),
                t('item1_sub_introduceDescArr_3'),
                t('item1_sub_introduceDescArr_4'),
            ],
            btnName: t('item1_sub_cta'),
            tips: t('item1_sub_tips'),
            id: 'EcoFlow_DELTA_3_Max_Plus',
            prodImg: 'https://websiteoss.ecoflow.com/upload/image/1756363891574/20250828-145014.jpg',
            url: 'https://www.ecoflow.com/jp/delta-3-max-series-portable-power-station',
        },
        {
            title: t('item2_title'),
            subtitle: t('item2_subtitle'),
            mainImg: 'https://websiteoss.ecoflow.com/upload/image/1756209655679/recommend-img-pc-1-2.jpg',
            mainImgH5: '',
            subImgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756353045412/recommend-img-pc-2-2.jpg',
                    h5: '',
                    text: t.rich('item2_sub_desc_1', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756259382546/recommend-img-pc-2-3.jpg',
                    h5: '',
                    text: t.rich('item2_sub_desc_2', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756297602528/recommend-img-pc-2-3.jpg',
                    h5: '',
                    text: t.rich('item2_sub_desc_3', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1756297602261/recommend-img-pc-2-5.jpg',
                    h5: '',
                    text: t.rich('item2_sub_desc_4', {
                        text1: (str: string) => <span className="gradient-text">{str}</span>,
                    }),
                },
            ],
            label: t('item2_sub_label'),
            introduceTitle: t('item2_sub_introduceTitle'),
            introduceDescArr: [
                t('item2_sub_introduceDescArr_1'),
                t('item2_sub_introduceDescArr_2'),
                t('item2_sub_introduceDescArr_3'),
                t('item2_sub_introduceDescArr_4'),
            ],
            btnName: t('item2_sub_cta'),
            tips: t('item1_sub_tips'),
            id: 'EcoFlow_DELTA_3_Max',
            prodImg: 'https://websiteoss.ecoflow.com/upload/image/1756363903432/20250828-145036.jpg',
            url: 'https://www.ecoflow.com/jp/delta-3-max-series-portable-power-station',
        },
    ];

    const handlePush = (index: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            listName: recommendData[index].introduceTitle,
            productName: recommendData[index].introduceTitle,
            buttonName: t('item2_sub_cta'),
        });
    };

    const handleJumpLine = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'line_icon_click',
            button_name: 'Line',
            url: 'https://lin.ee/GXsUSp7',
        });
    };

    const fields = [
        // 站点字段
        {
            id: '12713',
            type: 'multiple',
            value: [4],
            overwrite: false,
        },
    ];

    return (
        <section className={styles.ProductRecommend}>
            {recommendData.map((item, index) => (
                <div className={`recommend-card ${index < recommendData.length - 1 ? 'mb140' : ''}`} key={index} id={`${item.id}`}>
                    <div className="item-title">{item.title}</div>
                    <div className="item-subtitle">{item.subtitle}</div>
                    <div className="item-container">
                        <div className="scene-wrap">
                            <div className="main-img">
                                <EcoImg pc={item.mainImg} pad={item.mainImg} h5={item.mainImgH5}></EcoImg>
                            </div>
                            <div className="sub-imgs">
                                {item.subImgs.map((v, k) => (
                                    <div className="sub-img" key={`sub1${k}`}>
                                        <EcoImg pc={v.pc} pad={v.pc} h5={v.h5}></EcoImg>
                                        <div className="sub-text">
                                            <p>{v.text}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="introduce-wrap">
                            <div className="introduce-content">
                                <div className="left">
                                    <span className="label">{item.label}</span>
                                    <div className="title1">{item.introduceTitle}</div>
                                    <ul className="desc-ul">
                                        {item.introduceDescArr.map((v, k) => (
                                            <li key={`desc-ul${k}`}>
                                                <i></i>
                                                {v}
                                            </li>
                                        ))}
                                    </ul>
                                    <EfButton
                                        type="buy_now"
                                        className={`introduce-btn ${pageStatus === IPageStatus.statusA ? 'disabled' : ''}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={item.url}
                                        onClick={() => handlePush(index)}
                                    >
                                        {item.btnName}
                                    </EfButton>
                                    <div className="introduce-tips">{item.tips}</div>
                                </div>
                                <div className="right">
                                    <EcoImg pc={item.prodImg} alt={item.title}></EcoImg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <div className="subscription-box">
                <div className="subscription-content">
                    <div className="subscription-title">{t('subscription_title')}</div>
                    <EcoEmail
                        contactListId={['1935415334']}
                        source="WEB_NEW_PRODUCT_SUB"
                        fields={fields}
                        termsHtml={langText.term}
                        tipsObj={{
                            btnText: t('send_btn'),
                            placeholder: t('email_input'),
                            successTips: t('success_tips'),
                            tipsFailed: t('error_tips'),
                            tipsTypeError: t('error_tips'),
                        }}
                        subscribeData={{
                            sector_name: t('subscription_title'),
                            entry_position: '3',
                        }}
                    ></EcoEmail>
                </div>
                <div className="dividing"></div>
                <div className="line-qr">
                    <div className="line-title">{t('line_title')}</div>
                    <div className="line-desc">
                        {t.rich('line_desc', {
                            text1: (str: string) => <span>{str}</span>,
                        })}
                    </div>
                    <div className="qr-box">
                        <div className="qr">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1756263552322/M_gainfriends_2dbarcodes_GW%201.png"></EcoImg>
                        </div>
                        <EfButton className="qr-btn" href="https://lin.ee/GXsUSp7" target="_blank" rel="noopener noreferrer" onClick={handleJumpLine}>
                            {t('line_cta')}
                        </EfButton>

                        {/* <div className="credits">
                            <EcoImg className="credits-img" pc="https://websiteoss.ecoflow.com/upload/image/1756263556904/Group%201000007311.png"></EcoImg>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductRecommend;
